export default {

    operacaoCaptacaoEmAberto: {
        movimento: {},
        modalidade: {},
        rateio: {},
    },

}